import axios from 'axios';
import user from  '../utils/user';

export default {
  async getProfiles() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/profiles`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getToken() {
    return localStorage.getItem('user-token');
  },
  async listProfilesByHierarchy() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/profiles/hierarchy`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );

      const { data } = response;

      return data;
    } catch (error) {
      throw new Error('Erro ao buscar perfis');
    }
  },
};
